import { contrastRatio } from '@brig/theme/contrast';
import { palette } from '@brig/theme/tokens';
import { NATIONS, type Nation } from './nations.ts';

export { NATIONS, type Nation } from './nations.ts';
export { fortName, fortNames } from './fortNames.ts';
export { shipName, shipNames } from './shipNames.ts';
export { getPlayerColour, isPlayerColour, PLAYER_COLOURS, type PlayerColour } from './colours.ts';

export type NationId = string;

/** Nations in picker order. */
export function listNations(): readonly Nation[] {
  return [...NATIONS].sort((a, b) => a.order - b.order);
}

export function isNationId(id: unknown): id is NationId {
  return typeof id === 'string' && NATIONS.some((n) => n.id === id);
}

export function getNation(id: NationId): Nation {
  const nation = NATIONS.find((n) => n.id === id);
  if (!nation) throw new Error(`Unknown nation: ${id}`);
  return nation;
}

/** Ink or paper, whichever reads better on the nation's primary accent. */
export function onAccent(nation: Nation): string {
  return contrastRatio(palette.ink, nation.accent.primary) >=
    contrastRatio(palette.paper, nation.accent.primary)
    ? palette.ink
    : palette.paper;
}

/** The two nations of one game must differ. */
export function nationsDistinct(a: NationId, b: NationId): boolean {
  return a !== b;
}
